const SubDomainOverrideKey = 'EmbeddedAcademy:subDomainOverride';
const override = sessionStorage.getItem(SubDomainOverrideKey);
export const subDomain = override !== null && override !== void 0 ? override : 'app';